import {useState,useEffect, useMemo, useCallback} from 'react'
import ProductSearch from './ProductSearch'
import { Col, ListGroup, ListGroupItem, Row,Button, Container } from 'reactstrap'
import "./Product.css"
import { CountPages, PageCriteria } from '../../backoffice/dtos/products/pagesCriteria'
import { useGetPagesCountQuery, useGetShortDescriptionsQuery } from '../../backoffice/apis/descriptionsAPI'
import ProductEditModal from './ProductEditModal'
import { PageableProducts, Product } from '../../backoffice/dtos/products/product'
import { useTranslation } from 'react-i18next'
import { Loading } from '../views/Loading'




export function Products(
    {
        shown
    }:{
        shown: Boolean
    }
) {
    const {t} = useTranslation(['products'])
    const [nextPage, setNextPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(10)
    const [searchTerm, setSearchTerm] = useState<string>("")
    const [modalValue, setIsOpen] = useState<{ isOpen: boolean; product ?: Product }>({ isOpen: false })
    const [products, setProducts] = useState<PageableProducts>()

    const { data: productsResult, isFetching: productsAreFetching } = useGetShortDescriptionsQuery({ limit: limit, page: nextPage, query: searchTerm } as Partial<PageCriteria>, { skip: !shown, refetchOnMountOrArgChange: true })
    const { data: pages} = useGetPagesCountQuery({ limit: limit, query: searchTerm } as Partial<CountPages>, { skip: !shown, refetchOnMountOrArgChange: true })

    useEffect(()=>{
        setProducts(productsResult)
    },[productsResult])

    useEffect(() => {
        setNextPage(1)
    }, [limit, searchTerm])

    const toggle = useCallback((product: Product | undefined) => {
        setIsOpen({ isOpen: true, product: product})
    }, [])

    const close = useCallback(() => {
        setIsOpen({ isOpen: false })
    }, [])

    const mapList = useMemo(() => {
        if (productsAreFetching) {
            return <Loading className="m-2"/>
        } else if (products) {
            return products.products.map((product)=>{
                return (
                    <ListGroupItem key={product.code}>
                        <Row>
                            <Col md={2} className="d-flex flex-column justify-content-center">{product.code}</Col>
                            <Col md={5} className="d-flex flex-column justify-content-center">{product.description}</Col>
                            <Col md={3} className="d-flex flex-column justify-content-center">{product.shortDescription}</Col>
                            <Col className='d-flex flex-row justify-content-end'><Button color='primary' onClick={() => toggle(product)}><i className='fa fa-edit fa-lg'></i></Button></Col>
                        </Row>
                    </ListGroupItem>
                )
            })
        }
        return <></>;
    }, [productsAreFetching, products]);

    const pagesList = useMemo(() => {
        if (pages === undefined)
            return []

        return [
            <Button style={{borderTopRightRadius:'0px',borderBottomRightRadius:'0px'}} onClick = {() => setNextPage(prev => prev - 1)} disabled={nextPage <= 1}>Prev</Button>,
            <Button style={{borderRadius:'0px'}} color='primary' disabled>{nextPage}</Button>,
            <Button style={{borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px'}} onClick = {() => setNextPage(prev => prev + 1)} disabled={nextPage >= pages}>Next</Button>
        ]
    }, [pages, nextPage])

    return (
        <>
            <Container>
                <Row className='mt-1'>
                    <ProductSearch limit={limit} setLimit = {setLimit} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                    <Col lg="auto" className='text-right'>
                        {pagesList}
                    </Col>
                </Row>
                <ListGroup className='mt-4'>
                    <ListGroupItem>
                        <Row>
                            <Col md={2} style={{ fontWeight: 'bold' }}>{t('code').toUpperCase()}</Col>
                            <Col md={5} style={{ fontWeight: 'bold' }}>{t('description').toUpperCase()}</Col>
                            <Col md={3} style={{ fontWeight: 'bold' }}>{t('short_description').toUpperCase()}</Col>
                            <Col />
                        </Row>
                    </ListGroupItem>
                    {mapList}
                </ListGroup>
            </Container>
            {
                modalValue.isOpen &&
                    <ProductEditModal isOpen={modalValue.isOpen} toggle={close} selectedProduct={modalValue.product} />
            }
        </>
    )
}
